import { DropdownMenuItem } from '@neo/primitives/dropdown-menu'
import { ClipboardCopy } from 'lucide-react'
import { useParams } from 'router-v6'
import { errorToast } from 'v2/utils/toasts'
import { useVibeAgentStore } from '../store'

export const VibeCopySessionId = () => {
  const sessionId = useVibeAgentStore((state) => state.sessionId)
  const { id: flowId } = useParams()

  if (!sessionId) return null

  const textToCopy = flowId ? `Session ID: ${sessionId}\nAgent ID: ${flowId}` : sessionId

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy)
    } catch {
      errorToast({ title: 'Could not copy: clipboard unavailable' })
    }
  }

  return (
    <DropdownMenuItem onClick={handleCopy} data-testid="menu-copy-session-id">
      <ClipboardCopy className="w-4 h-4 mr-2" />
      Copy Session ID
    </DropdownMenuItem>
  )
}
